__turbopack_context__.v({
  "body": "SiteAlert-module-scss-module__Z7AxLq__body",
  "icon": "SiteAlert-module-scss-module__Z7AxLq__icon",
  "inner": "SiteAlert-module-scss-module__Z7AxLq__inner",
  "siteAlert": "SiteAlert-module-scss-module__Z7AxLq__siteAlert",
  "text": "SiteAlert-module-scss-module__Z7AxLq__text",
  "title": "SiteAlert-module-scss-module__Z7AxLq__title",
});
